/* Version: 3.5.137 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import useDerivedState from '../../../hooks/useDerivedState.js';
import useId from '../../../hooks/useId.js';

var mortgagesIcon = (function (_ref) {
  var alt = _ref.alt,
    controlledId = _ref.id;
  var _useDerivedState = useDerivedState(useId('mortgages-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        d: "M0 2.009h5.999v-2H0v2zm0 4h5.999v-2H0v2z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("g", {
        fill: "#FFF",
        children: /*#__PURE__*/jsx("path", {
          d: "M10 .667l-8.233 8.2v10.466h16.466V8.867L10 .667zm6.233 16.666h-3.1v-6.666H6.467v6.666H3.8V9.7L10 3.5l6.233 6.233v7.6zm-7.8 0v-4.666H11.1v4.666H8.433z"
        })
      }), /*#__PURE__*/jsxs("g", {
        transform: "translate(4 5.991)",
        children: [/*#__PURE__*/jsx("mask", {
          id: "".concat(id, "-mask"),
          fill: "#fff"
        }), /*#__PURE__*/jsx("path", {
          fill: "#FFF",
          d: "M-5 10.009h15v-16H-5z",
          mask: "url(#".concat(id, "-mask)")
        })]
      })]
    })]
  });
});

export { mortgagesIcon as default };
